<script lang="ts">
  type Option = {
    value: string;
    label: string;
  };

  export let placeholder: string;
  export let onChange: ((value: string) => void) | undefined = undefined;
  export let isDisabled: boolean = false;
  export let value: string = "";
  export let optionList: Array<Option> = [];
  export let mask: string | undefined = undefined;

  const handleChange = (e: Event) => {
    value = (e.target as HTMLInputElement).value;
    onChange && onChange(value);
  };

  const onComplete = ({ detail }: { detail: { unmaskedValue: string } }) => {
    value = detail.unmaskedValue;
    onChange && onChange(value);
  };

  $: mergedClass = `relative wrapper ${$$restProps.class || ""}`;
  let restProps = { ...$$restProps };
  delete restProps?.class;
</script>

<div class={mergedClass} {...restProps}>
  <select
    class="w-full outline-none"
    disabled={isDisabled}
    aria-label={placeholder}
    bind:value
    on:input={mask ? undefined : handleChange}
    on:complete={mask ? onComplete : undefined}>
    {#each optionList as option}
      <option value={option.value} selected={option.value === value}>{option.label}</option>
    {/each}
  </select>
  <span class="floating-label" class:small={value?.trim()}>{placeholder}</span>
</div>

<style>
  .floating-label {
    position: absolute;
    top: 1rem;
    left: 1rem;
    transition: all 0.2s;
    color: var(--color-grayscale-70);
    pointer-events: none;
  }

  select:focus + .floating-label,
  .floating-label.small {
    top: 0.5rem;
    font-size: 0.75rem;
  }

  select {
    border: 1px solid var(--color-grayscale-20);
    background-color: var(--color-grayscale-20);
    padding: 1.5rem 1rem 0.6rem 0.85rem;
    appearance: none;
    border-radius: var(--input-border-radius);
  }

  .wrapper::after {
    content: url("../../assets/icons/chevron-down.svg");
    position: absolute;
    top: 50%;
    right: 1rem;
    transform: translateY(-50%);
    pointer-events: none;
    font-size: 16px;
    color: #333;
  }

  select:focus {
    border: 1px solid var(--color-grayscale-50);
  }
</style>
